import { Component } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsFooterNavigationComponent } from '../../../../core/model';

@Component({
  selector: 'py-footer-navigation',
  templateUrl: './footer-navigation.component.html',
  styleUrls: ['./footer-navigation.component.scss'],
})
export class FooterNavigationComponent {
  readonly fullWidthFooterClass = 'full-width';

  constructor(public componentData: CmsComponentData<CmsFooterNavigationComponent>) {}

  hasClass(styleClasses: string, className: string): boolean {
    return styleClasses?.split && !!styleClasses.split(' ').find((name) => name === className);
  }
}
